window.trackEvent = (group, action, detail = null, feature = null) => {
	const payload = {
		event: 'uxTracking',
		uxElementGroup: group,
		uxAction: action
	}

	if (detail) payload.uxDetail = detail;
	if (feature) payload.uxFeature = feature;

	window.setTimeout(() => {
		if (typeof window.requestIdleCallback === 'function') {
			window.requestIdleCallback(() => {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push(payload);
			}, { timeout: 2000 });
		}
		else {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(payload);
		}
	}, 500);

	if (window.location.hostname === '127.0.0.1') console.log('Track event', payload);
};

const wishlistButtonEvents = (selector = '', suffix = null) => {
	const events = {}

	events[`ATW${suffix ? '-' + suffix : ''}`] = {
		selector: `${selector} wishlist-add-button:not(.added)`,
		detail: target => `ATW-${suffix ? suffix + '-' : ''}${target.closest('wishlist-add-button').dataset.title}`
	}
	
	events[`RFW${suffix ? '-' + suffix : ''}`] = {
		selector: `${selector} wishlist-add-button.added:not(.wishlist-add-button--view-wishlist)`,
		detail: target => `RFW-${suffix ? suffix + '-' : ''}${target.closest('wishlist-add-button').dataset.title}`
	}

	return events;
};

const globalEvents = {
	'Customise-Bundle': {
		selector: '.qatc__edit-preset, .product__edit-preset',
		detail: target => 
			`Customise-Bundle-${target.closest('.product-card, .product-main-wrapper').querySelector('.product-card__title, .product__title').innerText.trim()}`
	}
}

const sections = [
	{
		name: 'Announcement Bar',
		selector: '.announcement-bar *',
		listeners: {
			'Announcement link': '.announcement-bar__message'
		}
	},
	{
		name: 'Navbar',
		selector: 'site-nav *',
		listeners: {
			'top-level-category': '.nav-items > nav-item > .nav__link',
			'D-2nd-level-category': '.desktop-nav__submenus h2 > a',
			'D-3rd-level-category': '.desktop-nav__submenus li > a',
			'D-viewAll': '.desktop-nav__view-all',
			'M-2nd-level-category': '.mobile-nav__submenus[data-depth="1"] > .nav-item > .nav__link',
			'M-3rd-level-category': '.mobile-nav__submenus[data-depth="2"] > .nav-item > .nav__link',
			'M-back': 'button[name="back"]'
		}
	},
	{
		name: 'PDP',
		selector: '.product-single *, .template-product:not([data-template^="product.bundle-builder"]) *',
		listeners: {
			...globalEvents,
			'Breadcrumb': '.breadcrumb a',
			'Clickable-X-reviews': '.review-rating a',
			'Swatch-change': {
				selector: 'swatch-link',
				detail: target => `Swatch-change-${target.closest('swatch-link').dataset.colour}`
			},
			'Size-select': {
				selector: 'option-selector input[name="size"]',
				detail: target => `Size-select-${target.value}`
			},
			'Size-guide-open': {
				selector: 'button[name="size-guide"]',
				detail: target => `Size-guide-${target.closest('option-selector').dataset.selected}`
			},
			'Size-guide-close': '.size-guide-container .close-icon',
			'Size-guide-ignore': '.size-guide-container .close-overlay',
			'ATC': {
				selector: '#AddToCart-product-template',
				detail: _ => `ATC-${document.querySelector('.product__title').innerText.trim()}`
			},
			'Afterpay-Snippet-open': 'bnpl-widget',
			...wishlistButtonEvents('.product-main-wrapper'),
			'Details-section-open': {
				selector: '.product-details-item:not(.open) .details-title',
				detail: target => target.closest('h4').innerText.trim()
			},
			'Details-section-close': {
				selector: '.product-details-item.open .details-title',
				detail: target => target.closest('h4').innerText.trim()
			},
			'Shipping-policy-pdp': '.product-details-item a[href*="shipping-returns"]',
			'BYOB-link-pdp': '.byob-block-container',

			'Img-open': '.product__media--image',
			'Img-select': '.product__thumbnail',
			'Img-zoom': '.pswp:not(.pswp--zoomed-in) .pswp__img, .pswp:not(.pswp--zoomed-in) .pswp__button--zoom',
		}
	},
	{
		name: 'Collection',
		selector: '.template-collection *',
		listeners: {
			...globalEvents,
			'Breadcrumb': '.breadcrumb a',
			'pill-child': {
				selector: '.pill-list-item a',
				defaultOnly: true
			},
			'pill-grandchild': '.pill-grandchildren a',
			'Sort-by': {
				selector: '.sortby-content-item',
				detail: target => target.innerText.trim()
			},
			...wishlistButtonEvents(),
			'View-item': {
				selector: '.product-card a',
				detail: target => 'View-item-' + target.closest('.product-card').querySelector('.product-card__title').innerText.trim()
			},
			'QATC': {
				selector: '.product-card .qatc__button, .product-card .qatc__atc',
				detail: target => 'QATC-' + target.closest('.product-card').querySelector('.product-card__title').innerText.trim()
			},
			'Next-page': '.pagination .next',
			'Previous-page': '.pagination .prev',
			'Pagination-click': '.pagination .page',
		}
	},
	{
		name: 'Footer',
		selector: '.site-footer *, #gorgias-chat-container *',
		listeners: {
			'Footer-link': {
				selector: '.site-footer__item a',
				detail: target => target.closest('.site-footer__item').querySelector('.h4').innerText.trim()
			}
		}
	},
	{
		name: 'Homepage',
		selector: '.template-index *',
		listeners: {
			'Hero': '.hero-uni-slide',
      'Pill-toggle': {
        selector: '.pill-toggle',
        detail: (target) =>
          'Pill-toggle collection ' + target.closest('a').innerText.trim(),
      },
			'Carousel-card-view-item': {
				selector: '.card a',
				detail: target => 'Carousel-card-view-item ' + target.innerText.trim()
			},
			...wishlistButtonEvents(),
			'Grid-view-collection': {
				selector: '.collection-list-slider-section a',
				detail: target => 'Grid-view-collection ' + target.closest('a').innerText.trim()
			},
		 'Journal-feature-image': '.article__list-image-container, .article__title',
		 'Journal-feature-shop-button': '.article__details-container .btn.secondary',
		 'Journal-feature-more-button': '.article__details-container .btn.hero__btn',
		 'Grid-journal-view-article': '.article-show-list-item a',
		 'Grid-journal-more-button': '.hpa .read-more-btn',
		 'ig-handle': '.instagram-section h2',
		 'ig-feed': '.instafeed-shopify a',
     'Carousel-right-arrow-click': {
      selector: '.card-carousel__arrow--next',
      detail: (target) =>
        'Carousel-right-arrow-click ' +
        document.querySelector('.pill-toggle.active').innerText.trim(),
      },
      'Carousel-left-arrow-click': {
        selector: '.card-carousel__arrow--prev',
        detail: (target) =>
          'Carousel-left-arrow-click ' +
          document.querySelector('.pill-toggle.active').innerText.trim(),
      },
      'Carousel-see-more': {
        selector: '.last-card-link',
        detail: (target) =>
          'Carousel-see-more ' +
          document.querySelector('.pill-toggle.active').innerText.trim(),
      },
		}
	},
	{
		name: 'Account',
		selector: '[data-template^="customers"] *',
		listeners: {
			'View-addresses': 'a[href="/account/addresses"]',
			'Add-a-new-address': '#AddressNewButton',
			'Return-to-account': 'a[href="/account"]',
			'Edit-address': '.address-edit-toggle',
			'Delete-address': '.address-delete',
			'Order-detail': {
				selector: '.myaccount__order-history a',
				detail: `Order-detail-${target => target.innerText.trim()}`
			},
			'Track-shipment': '.fulfillment_details > p > a',
			'Redeem-now': 'button[aria-label="Redeem Now"]',
			'Reward-history': 'button[aria-label="Rewards History"], button[aria-label="Rewards History"] *',
			'Share-dream': '.yotpo-friends-share-button',
			'Social-link': {
				selector: '.yotpo-share-button-widget',
				detail: target => 'Social-link-' + target.closest('.yotpo-share-button-widget').ariaLabel
			}
		}
	},
	{
		name: 'Wishlist',
		selector: '.wishlist-page *',
		listeners: {
			'RFW': '.wishlist-item__remove',
			'View-item': '.wishlist-item__name',
			'Edit-Bundle': '.wishlist-item__edit',
			'Show-bundle-items': 'button[name="show"]',
			'Hide-bundle-items': 'button[name="hide"]',
			'Quantity-increase': '.wishlist-item__qty-increase',
			'Quantity-decrease': '.wishlist-item__qty-decrease',
			'ATC': 'button[name="add"]',
			'Add-all-to-cart': 'button[name="add-all"]',
			'Clear-entire-wishlist': 'button[name="clear"]',
			...wishlistButtonEvents('.ss-profile-wishlist-recommendations', 'also-like'),
			'View-item-also-like': '.ss-profile-wishlist-recommendations .product-card a'
		}
	},
	{
		name: 'BYOB',
		selector: '[data-template^="product.bundle-builder"] *',
		listeners: {
			'Img-zoom': '.pswp:not(.pswp--zoomed-in) .pswp__img, .pswp:not(.pswp--zoomed-in) .pswp__button--zoom',
		}
	},
	{
		name: 'BYOB',
		selector: 'cart-contents *',
		listeners: {
			'begin_checkout': {
				selector: 'cart-contents:has(cart-item[data-product-handle="the-bed-threads-build-your-own-bundle"]) .checkout',
				once: true
			},
		}
	},
	{
		name: 'BYOB Landing Page',
		selector: '[data-template^="product.bundle-builder"] #MainContent *',
		listeners: {
			'Sticky-CTA': 'bundle-sticky-cta bundle-start-button',
			'Hero-CTA': '.bundle-hero bundle-start-button',
			'Hero-Second-CTA': '.alchemy__element bundle-start-button',
			'Hero-Reviews': '.bundle-hero .bundle-hero__reviews a',
			'QATC': {
				selector: '.product-card .qatc__button, .product-card .qatc__atc',
				detail: target => 'QATC-' + target.closest('.product-card').querySelector('.product-card__title').innerText.trim()
			},
			...globalEvents,
			...wishlistButtonEvents()
		}
	},
	{
		name: 'Side Cart',
		selector: 'cart-drawer *',
		listeners: {
			'View-item': {
				selector: '.card a',
				detail: target => 'View-item-' + target.innerText.trim()
			},
			'QATC': {
				selector: '.qatc__button, .qatc__atc',
				detail: target => 'QATC-' + target.closest('.card').querySelector('.card__heading').innerText.trim()
			},
			'Close-Button': 'button[name="close"]',
			'Close-Background': '.cart-drawer__bg',
			'Continue': '.cart__continue',
		},
	},
	{
		name: 'Side Cart',
		selector: '.site-header__cart *',
		listeners: {
			'Open': {
				selector: '*',
				feature: _ => document.querySelector('.cart-footer') ? document.querySelector('.cart-footer[data-shipping="0.00"]') ? 'Above threshold' : 'Below threshold' : 'Cart empty',
			}
		}
	},
	{
		name: 'Cart',
		selector: 'cart-item *',
		listeners: {
			'show-hide-child-items': {
				selector: 'button[name="collapse"]',
				detail: target => {
					const isCollapsed = target.closest('cart-item')?.dataset.collapsed === 'true';
					const hasFeatureCollapse = !!document.querySelector('.feature-collapse-bundle');
					return (isCollapsed !== hasFeatureCollapse) ? 'show' : 'hide';
				}
			}
		}
	},
	{
		name: 'PDP Add-on',
		selector: '.product-single .product-recommendations *',
		listeners: {
			'View-item': {
				selector: '.card a',
				detail: target => 'View-item-' + target.innerText.trim()
			},
			'QATC': {
				selector: '.qatc__button, .qatc__atc',
				detail: target => 'QATC-' + target.closest('.card').querySelector('.card__heading').innerText.trim()
			}
		},
	},
	{
		name: 'Gift Guide',
		selector: 'body[data-handle="gift-guide"] *',
		listeners: {
			'Tab-click': {
				selector: '.collection-tabs tab-button',
				detail: target => target.closest('.shopify-section').previousElementSibling?.querySelector('h2')?.innerText.trim() ?? 'Collection Tabs',
				feature: target => target.innerText.trim()
			}
		}
	}
];

document.addEventListener('click', e => {
	if (!e.isTrusted) return;

	for (const section of sections) {
		if (e.target.matches(section.selector)) {

			for (const listener in section.listeners) {
				const data = section.listeners[listener];
				if (data.once) delete section.listeners[listener];
				const selector = data.selector || data;

				if (data.defaultOnly && e.defaultPrevented) continue;

				if (e.target.matches(selector) || e.target.closest(selector)) {
					const action = data.action || listener;

					window.trackEvent(
						section.name, 
						typeof action == 'function' ? action(e.target) : action,
						data.detail ? (typeof data.detail === 'function' ? data.detail(e.target) : data.detail) : null,
						data.feature ? (typeof data.feature === 'function' ? data.feature(e.target) : data.feature) : null
					);
				}
			}
		}
	}
}, { capture: true });


// Scroll tracking

let group = null;
const template = document.body.dataset.template;

if (template.includes('index')) group = 'Home';
else if (template.includes('collection')) group = 'Collection';
else if (template.includes('bundle-builder')) group = 'BYOB';
else if (template.includes('product')) group = 'pdp';
else if (template.includes('blog') || template.includes('article')) group = 'Journal';
else if (template.includes('page')) {
	if (document.querySelector('.sanity-blog-page')) group = 'Journal';
	else group = 'Page';
}

if (group != null) {
	const getTitle = elem => {
		const tags = ['h1', 'h2', 'h3', 'a', 'p'];
		const titleElem = tags.map(tag => elem.querySelector(tag)).find(e => e);
		const title = titleElem && titleElem.innerText.trim().length > 0 ? titleElem.innerText : elem.id;
		return title;
	}

	const sectionElems = 
		[...document.querySelectorAll('main .shopify-section, .sanity-main-article > *, .sanity-blog-page > *, .swatch-fd-section-wrapper > *')]
		.filter(e => getTitle(e));

	for (const section of sectionElems) {
		const observer = new IntersectionObserver(entries => {
			if (entries.some(e => e.isIntersecting)) {
				observer.disconnect();
				window.trackEvent(group, 'Scroll', `${sectionElems.indexOf(section) + 1}-${getTitle(section)}`);
			}
		},{ rootMargin: '0px 0px -50% 0px' });

		observer.observe(section);
	}
}